export default __webpack_public_path__ + "static/ChineseRocksRg-5801070c35cc64a95dd1127b07409c3c.woff2";